import { AppRoute } from '@app/core/routing/AppRoute';
import { Switch, useRouteMatch } from 'react-router-dom';
import { AdminStationGroupsListPage } from './list/AdminStationGroupsListPage';
import { AdminStationGroupsViewPage } from './view/AdminStationGroupsViewPage';

/** Nested routes for read-only station groups admin (list + show). */
export function AdminStationGroupsRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AppRoute path={`${path}/:id`} component={AdminStationGroupsViewPage} />
      <AppRoute path={path} component={AdminStationGroupsListPage} />
    </Switch>
  );
}
